import { IdentityClientSettings } from "@gsgroup/gsgroup-react-ui";
import { BackendData } from "./backendDataParser";

export function SelectClient(currentValue: any, key: any) {
    const localStorageValue = window.localStorage.getItem(key);
    if ((localStorageValue && localStorageValue !== currentValue) || localStorageValue === null || localStorageValue === undefined) {
        window.localStorage.setItem(key, JSON.stringify(currentValue));
    }
    window.location.reload();
}

export function ClientOptions(currentValue: any, key: any) {
    const localStorageValue = window.localStorage.getItem(key);
    if ((localStorageValue && localStorageValue !== currentValue) || localStorageValue === null || localStorageValue === undefined) {
        window.localStorage.setItem(key, JSON.stringify(currentValue));
    }
}

export function getSelectedClient() {
    try {
        const selectedClientJson = localStorage.getItem('selectedClient');

        if (selectedClientJson === null) {
            throw new Error('Selected backend cannot be null');
        }

        const selectedClient: BackendData = JSON.parse(selectedClientJson);

        return selectedClient;
    } catch (error) {
        console.log(error);

        throw error;
    }
}

export function ClearLocalStorageItem(itemName: string) {
    window.localStorage.removeItem(itemName);
}

const IDENTITY_CLIENT_SETTINGS_KEY = "IDENTITY_CLIENT_SETTINGS_KEY";

export function saveIdentityClientSettings(identityClientSettings: IdentityClientSettings) {
    const localStorageValue = localStorage.getItem(IDENTITY_CLIENT_SETTINGS_KEY);

    const identityClientSettingsAsJson = JSON.stringify(identityClientSettings);

    if (localStorageValue !== identityClientSettingsAsJson) {
        localStorage.setItem(IDENTITY_CLIENT_SETTINGS_KEY, identityClientSettingsAsJson);
    }
}

export function getIdentityClientSettings() {
    try {
        const identityClientSettingsAsJson = localStorage.getItem(IDENTITY_CLIENT_SETTINGS_KEY);

        if (identityClientSettingsAsJson === null) {
            throw new Error('Identity Client Settings cannot be null');
        }

        const identityClientSettings: IdentityClientSettings = JSON.parse(identityClientSettingsAsJson);

        return identityClientSettings;
    } catch (error) {
        console.log(error);

        throw error;
    }
}